






































































































































































































































































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import ImageUpload from '@/components/ImageUpload.vue'
//import TaxRateEditor from '@/components/TaxRateEditor.vue'
import { mapState } from 'vuex'

interface StructureData {
  name: string
  fullName: string
  address: string
  address2: string
  postalCode: string
  city: string
  legalStatus: string
  type: string
  logo: string
  siret: string
  signature: string
  VATintra: string
  email: string
  phone: string
  bankInfos: string
  thirdPartyBankInfos: string
  taxStatus: number
  taxRate: string
  productCategoryCompta: string
  bankAccount: string
  partnerApiConfig: string
  code: string
  duePeriod: number | null
  tms_apikey: string
  tms_code: string
  rcs: string
  naf: string
  capital: string
  agreement: string
  color: string
  emailFrom: string
  emailFromInvoice: string
  footer: string
  defaultRequisitionFees: string
}

export default Vue.extend({
  components: { Nav, ImageUpload /*, TaxRateEditor */ },
  data() {
    return {
      busy: false,
      isDisabled: false,
      structureData: {
        name: '',
        fullName: '',
        address: '',
        address2: '',
        postalCode: '',
        city: '',
        legalStatus: '',
        type: '',
        logo: '',
        siret: '',
        signature: '',
        VATintra: '',
        email: '',
        phone: '',
        bankInfos: '',
        thirdPartyBankInfos: '',
        taxStatus: 0,
        taxRate: '',
        productCategoryCompta: '',
        bankAccount: '',
        partnerApiConfig: '',
        code: '',
        duePeriod: null,
        tms_apikey: '',
        tms_code: '',
        rcs: '',
        naf: '',
        capital: '',
        agreement: '',
        color: '',
        emailFrom: '',
        emailFromInvoice: '',
        footer: '',
        defaultRequisitionFees: '',
      } as StructureData,
      autocompleteNone: 'none',
      changeDetected: null as null | boolean,
      defaultBankAccountConfig: '',
      defaultTaxRateConfig: '',
      defaultProductCategoryComptaConfig: '',
    }
  },
  computed: {
    ...mapState(['user', 'connectedAs']),
    isExeveAdmin(): boolean {
      return this.user !== null && (!!this.user.isAdmin || this.connectedAs !== null)
    },
    structureId(): number {
      return Number(this.$route.params.id)
    },
    structureTitle(): string {
      return this.structureData.name || this.structureData.fullName || 'structure'
    },
    logoUrl(): string {
      if (this.structureId && this.structureData.logo) {
        return `${process.env.VUE_APP_API_URL}/structure/${this.structureId}/logo`
      }
      return ''
    },
  },
  watch: {
    structureId: {
      immediate: true,
      handler() {
        this.fetchStructure()
      },
    },
    structureData: {
      deep: true,
      immediate: true,
      handler() {
        if (this.changeDetected === false) {
          this.changeDetected = true
        }
      },
    },
  },
  mounted() {
    if (this.isExeveAdmin) {
      this.fetchDefaultConfigurations()
    }

    this.$nextTick(() => {
      this.changeDetected = false
    })
  },
  methods: {
    setAttribute() {
      this.autocompleteNone = 'none'
    },
    cancelForm() {
      this.goBack()
    },
    goBack() {
      this.$router.back()
    },
    setStructureData(data: Partial<StructureData>) {
      const rawProductCategoryCompta = (data as Record<string, unknown>).productCategoryCompta

      this.structureData = {
        name: data.name || '',
        fullName: data.fullName || '',
        address: data.address || '',
        address2: data.address2 || '',
        postalCode: data.postalCode || '',
        city: data.city || '',
        legalStatus: data.legalStatus || '',
        type: data.type || '',
        logo: data.logo || '',
        siret: data.siret || '',
        signature: data.signature || '',
        VATintra: data.VATintra || '',
        email: data.email || '',
        phone: data.phone || '',
        bankInfos: data.bankInfos || '',
        thirdPartyBankInfos: data.thirdPartyBankInfos || '',
        taxStatus: Number(data.taxStatus) === 1 ? 1 : 0,
        taxRate: typeof data.taxRate === 'string' ? data.taxRate : JSON.stringify(data.taxRate ?? {}),
        productCategoryCompta:
          typeof rawProductCategoryCompta === 'string'
            ? rawProductCategoryCompta
            : JSON.stringify(rawProductCategoryCompta ?? []),
        bankAccount: typeof data.bankAccount === 'string' ? data.bankAccount : JSON.stringify(data.bankAccount ?? {}),
        partnerApiConfig:
          typeof data.partnerApiConfig === 'string'
            ? data.partnerApiConfig
            : JSON.stringify(data.partnerApiConfig ?? {}, null, 2),
        code: data.code || '',
        duePeriod: data.duePeriod ?? null,
        tms_apikey: data.tms_apikey || '',
        tms_code: data.tms_code || '',
        rcs: data.rcs || '',
        naf: data.naf || '',
        capital: data.capital || '',
        agreement: data.agreement || '',
        color: data.color || '',
        emailFrom: data.emailFrom || '',
        emailFromInvoice: data.emailFromInvoice || '',
        footer: data.footer || '',
        defaultRequisitionFees: data.defaultRequisitionFees || '',
      }
    },
    fetchStructure() {
      if (!this.structureId) {
        return
      }
      this.busy = true
      this.$api
        .get(`/structure/${this.structureId}`)
        .then((response) => {
          const apiResponse = response.data
          this.setStructureData(apiResponse.data)
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger la structure.',
          })
        })
        .finally(() => {
          this.busy = false
          this.$nextTick(() => {
            this.changeDetected = false
          })
        })
    },
    fetchDefaultConfigurations() {
      this.$api
        .get('/structure/default-configurations')
        .then((response) => {
          const apiResponse = response.data
          const defaults = apiResponse?.data ?? {}
          this.defaultBankAccountConfig = JSON.stringify(defaults.bankAccount ?? {}, null, 2)
          this.defaultTaxRateConfig = JSON.stringify(defaults.taxRate ?? {}, null, 2)
          this.defaultProductCategoryComptaConfig = JSON.stringify(defaults.productCategoryCompta ?? {}, null, 2)
        })
        .catch(() => {
          this.defaultBankAccountConfig = ''
          this.defaultTaxRateConfig = ''
          this.defaultProductCategoryComptaConfig = ''
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger les configurations standards.',
          })
        })
    },
    submit() {
      this.busy = true
      const loading = this.$loading({
        target: '.form-panel',
        text: 'Chargement des donnees...',
      })

      const payload: Record<string, unknown> = { ...this.structureData }

      const jsonFields = ['taxRate', 'bankAccount', 'productCategoryCompta', 'partnerApiConfig']

      jsonFields.forEach((field) => {
        const value = payload[field]
        if (value && typeof value === 'string') {
          try {
            payload[field] = JSON.parse(value)
          } catch (e) {
            // Keep as string if JSON parsing fails
          }
        }
      })

      this.$api
        .put(`/structure/${this.structureId}`, payload)
        .then((response) => {
          const apiResponse = response.data
          this.setStructureData(apiResponse.data)
          this.$notify({
            type: 'success',
            title: 'Succes',
            message: 'Structure modifiee avec succes !',
          })
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Une erreur est survenue. Veuillez reessayer.',
          })
        })
        .finally(() => {
          this.busy = false
          this.changeDetected = false
          loading.close()
        })
    },
  },
})
